import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import ReactTable from "../Components/ReactTable";
import RunIdLink from "../IngestionLogs/Columns/RunIdLink";
import JsonPayloadModal from "../Components/JsonPayloadModal";
import {addLabelToOptionsIfNotExist} from "../../utils/maybeAddLabelToOptions";
import SelectDropdown from '../Components/Dropdowns/SelectDropdown';

const MeasuresExtractsDagLogs = ({
                                     airflowUrl,
                                     airflowVersion,
                                     data,
                                     tableTitle,
                                     pageSize,
                                     outlet,
                                     marketPeriodList,
                                     runIdentifierMarketPeriods,
                                     onMarketPeriodChange
                                 }) => {
    const dataLoading = !(airflowUrl && data)
    return (
        <Fragment>
            <h2>{tableTitle}</h2>
            <ReactTable
                filterable
                data={data || []}
                columns={[
                    {
                        header: 'Run Id',
                        accessorKey: 'runid',
                        filterable: false,
                        className: 'non-numeric-field',
                        cell: ({row, getValue}) => <RunIdLink
                            airflowUrl={airflowUrl}
                            airflowVersion={airflowVersion}
                            {...row}
                            value={getValue()}
                            getDisplayText={(row) => row.conf.run_identifier}/>,
                    },
                    {
                        header: 'Run Configuration',
                        accessorKey: 'conf',
                        enableColumnFilter: false,
                        cell: ({getValue}) => <JsonPayloadModal value={getValue()}/>,
                    },
                    {
                        header: 'Run Period',
                        filterable: true,
                        accessorKey: 'conf.markets_period'
                    },
                    {
                        header: 'Period Release',
                        filterable: false,
                        className: 'non-numeric-field table-dropdown',
                        cell: (props) => <SelectDropdown
                            id={`period_release_${props?.row.original.conf.run_identifier}_dropdown`}
                            containerClassName={'period-release-dropdown-container'}
                            dataTestId={`${props?.row.original.conf.run_identifier}-period-release-dropdown-container`}
                            menuPosition={"fixed"}
                            menuPlacement={"bottom"}
                            menuShouldBlockScroll={true}
                            maxMenuHeight={200}
                            height={32}
                            selectValue={runIdentifierMarketPeriods && getPeriodForRunIdentifier(runIdentifierMarketPeriods, props.row.original.conf.run_identifier)?.value}
                            options={addLabelToOptionsIfNotExist(marketPeriodList)}
                            onChange={(option) => onMarketPeriodChange({
                                outlet,
                                runIdentifier: props.row.original.conf.run_identifier,
                                runId: props.row.original.runid,
                                marketPeriod: option.value
                            })}
                        />
                    }
                ]}
                loading={dataLoading}
            />
        </Fragment>);
};

function getPeriodForRunIdentifier(runIdentifierMarketPeriods, originalRunIdentifier) {
    for (const [period, runInfo] of Object.entries(runIdentifierMarketPeriods)) {
        if (runInfo.runIdentifier === originalRunIdentifier) {
            return {value: period, label: period};
        }
    }
    return undefined;
}

MeasuresExtractsDagLogs.propTypes = {
    airflowUrl: PropTypes.string.isRequired,
    airflowVersion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    data: PropTypes.shape(PropTypes.arrayOf(PropTypes.object)).isRequired,
    tableTitle: PropTypes.string,
    pageSize: PropTypes.number,
    outlet: PropTypes.string,
    marketPeriodList: PropTypes.arrayOf(PropTypes.string).isRequired,
    runIdentifierMarketPeriods: PropTypes.object,
    onMarketPeriodChange: PropTypes.func
};

export default MeasuresExtractsDagLogs;